<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div class="cf-flex cf-flex--row cf-flex--gap-20 cf-flex--align-center cf-flex--justify-space-between cf-modal__subheader cf-modal__subheader--sticky">
      <h3 class="cf-title cf-title--3">
        {{ item.displayName }}
      </h3>

      <button
        v-if="allowDeselect && selectedModifiers"
        class="cf-button cf-button--secondary cf-button--md"
        type="button"
        title="Deselect"
        @click="deselect"
      >
        Reset
      </button>
    </div>

    <validated-form
      name="menuItemChild"
      @valid-submit="update"
    >
      <!-- Globally registered comp -->
      <cf-modifier-groups
        v-if="item.modifierGroups.length > 0"
        :groups="item.modifierGroups"
        :read-only="readOnly"
        :hide-prices="selectedLocation.features.HidePrices"
        :selected-modifiers="selectedModifiers"
        @selected="modifiersSelectedHandler"
      />

      <div class="cf-modal__footer cf-modal__footer--row cf-modal__footer--sticky">
        <button
          v-if="!readOnly"
          class="cf-button cf-button--primary cf-button--lg cf-button--auto"
          type="submit"
        >
          Select
        </button>
      </div>
    </validated-form>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import calculatePriceWithModifiers from '@/helpers/calculate-price-with-modifiers';


  export default {
    name: 'CfModifierMenuItemChild',

    props: {
      allowDeselect: {
        type: Boolean,
        default: false
      },

      item: {
        type: Object,
        required: true
      },

      readOnly: {
        type: Boolean,
        default: false
      },

      selectedQuantity: {
        type: Number,
        default: null
      },

      selectedModifiers: {
        type: Array,
        default: null
      }
    },

    data() {
      return {
        modifiers: [],
        quantity: 1
      };
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      priceWithModifiers() {
        return calculatePriceWithModifiers(this.item, this.modifiers) * this.quantity;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      close() {
        this.$emit('close');
      },

      createdHandler() {
        this.quantity = this.selectedQuantity || 1;
      },

      deselect() {
        this.$emit('deselect', this.item.menuItemId);
      },

      modifiersSelectedHandler(modifiers) {
        this.modifiers = modifiers;
      },

      update() {
        this.$emit('update', {
          item: this.item,
          quantity: this.quantity,
          modifiers: this.modifiers
        });
      }
    }
  };
</script>
